module.exports = __webpack_public_path__ + "static/media/swab-instruction-step04.60b50821.png";